import React from 'react';
import { NoMatchText, MacroButton } from '../../DecisionTree.styles';
import { useDispatch } from 'react-redux';
import { addEdgeToDecisionTreePath } from 'actions/searchActions';

export const DTNoResultsLink = () => {
  const dispatch = useDispatch();

  return (
    <>
      <NoMatchText marginTop={'10px'}>Next steps you can take:</NoMatchText>
      <NoMatchText marginTop={'10px'}>1. You can also try searching by the customer's order number.</NoMatchText>
      <NoMatchText marginTop={'7px'}>
        2. If you still can't find a result, please ask the customer for the email <br />
        they used to create the order using the macro below.
      </NoMatchText>
      <MacroButton active={true} onClick={() => dispatch(addEdgeToDecisionTreePath('no_search_results'))}>
        GET MACRO
      </MacroButton>
      <NoMatchText marginTop={'0px'}>
        3. Once you have received a response from the customer, use the updated <br />
        customer information to search again.
      </NoMatchText>
    </>
  );
};
